<!--
 * @Description: 运维统计
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-03-22 15:41:18
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-03-29 16:45:41
 -->
<template>
  <div class="maintenanceStatistics">
    <div class="item" v-for="(item, index) in statisticsList" :key="index">
      <div class="label" :style="{'background-image':'url(' + item.bgSrc + ')'}">{{item.label}}</div>
      <div class="value">{{item.value}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'maintenanceStatistics',
  components: {
  },
  data () {
    return {
      statisticsList: [
        {
          name: 'device',
          label: '维护设备总数',
          value: 0,
          bgSrc: '/static/img/layout/titleBg-green.png',
        },
        {
          name: 'user',
          label: '系统用户总数',
          value: 0,
          bgSrc: '/static/img/layout/titleBg-yellow.png',
        },
        {
          name: 'mileage',
          label: '维护总公里数',
          value: 0,
          bgSrc: '/static/img/layout/titleBg-blue.png',
        },
        {
          name: 'station',
          label: '收费站总数',
          value: 0,
          bgSrc: '/static/img/layout/titleBg-green.png',
        },
      ],
    }
  },
  methods: {
    /**
     * @description                   获取数据
     * @return {undefied}             无返回值
     */
    getData () {
      this.$http.get('/rest/screen/lcgl/summary').then(res => {
        if (res.code === 0) {
          this.statisticsList.map(k => {
            k.value = res.data[k.name]
          })
        } else {
          this.$message({
            message: res.msg,
            type: 'error',
          })
        }
      })
    },
  },
  created () {
    this.getData()
  },
}
</script>

<style lang="less" scoped>
  .maintenanceStatistics {
    width: 100%;
    height: 100%;
    background: url('/static/img/layout/staticsBg.png');
    background-size: 100% 100%;
    display: inline-flex;
    justify-content: space-around;
    align-items: center;
    flex-wrap: wrap;
    .item {
      width: 35%;
      height: 49%;
      display: inline-flex;
      justify-content: space-around;
      align-items: center;
      align-content: space-around;
      flex-wrap: wrap;
      margin-top: 0.5%;
      .label {
        display: inline-block;
        width: 95%;
        height: 38%;
        background-size: 100% 100%;
        color: #fff;
        font-size: 1.5vh;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: space-around;
      }
      .value {
        font-size: 2.2vh;
        color: #fff;
        text-align: center;
        font-weight: bold;
      }
    }
  }
</style>
